import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';
import { CertificadoServiceEntity } from './servicio-certificado-ocupacional.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioHistoriaService {

  constructor( private requestUrl : ReportesRequestService ) { }

  public async getResponse( objetoRequest : CertificadoServiceEntity ) {
    try {
      let response = await this.requestUrl.getHistoria(
        "/consultar/consultar-historia",
        [ objetoRequest.codigoBaseDatos, objetoRequest.id ]
      );

      if( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch(exception) {
      console.log(exception);
    }
  }

  public async getResponseHistoria( objetoRequest : CertificadoServiceEntity ) {

    try {

      let response = await this.requestUrl.getRequest(
        'historia/historia-cenpresabil',
        [ objetoRequest.codigoBaseDatos, { "ln_id_trtmnto_asistn" : objetoRequest.id } ]
      );

      if( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch ( exception ) {
      console.log( "Servico Certificado Ocupacional Exception:\n" + exception );
    }

  }

}

export interface HistoriaDatosEntity {
  nombre : string,
  fechaAtencion : string,
  ciudadPatronal : string,
  empresa : string,
  tipoIdentificacion : string,
  numeroIdentificacion : string,
  fechaNacimiento : string,
  sexo : string,
  direccion : string,
  ciudadNacimiento : string,
  sector : string,
  nit : string,
  medicoAtencion : string,
  descripcionMedico : string,
  registroMedico : string,
  cargo : string,
  telefonoAfiliado : string,
  ciudadAfiliado : string,
  estadoCivil : string,
  eps : string,
  arl : string,
  afp : string,
  nivelEscolar : string,
  empleador : string,
  prosefion : string
}
